export const DEX_DYN_WIDGET_TYPE_ID = 'DexDynWidget';
